<template>
<div id="login">
    <!-- <img class="login-bg" src="../../static/img/ibroadcast/bg_record.jpg" v-if="loginType === 'irecord'">
    <img class="login-bg" src="../../static/img/ibroadcast/bg_editor.jpg" v-else-if="loginType === 'ieditor'">
    <img class="login-bg" src="../../static/img/ibroadcast/bg_check.jpg" v-else-if="loginType === 'audit'">
    <img class="login-bg" src="../../static/img/ibroadcast/bg_monitor.jpg" v-else-if="loginType === 'stats'"> -->
    <!-- <img class="login-bg" src="../../static/img/ibroadcast/bg_guest.jpg" v-else> -->
    <img class="login-bg" src="../../static/img/ibroadcast/bg_guest.jpg">
    <!-- <div class="login-content">
        <div class="content-wrap">
        </div>
    </div> -->

    <!-- <div class="content-form" style="border:5px solid red;"> -->
    <el-row type="flex" justify="end" align="middle" class="content-form">
        <!-- <el-col :xs="0" :sm="0" :md="6" :lg="6" style="border:5px solid red;">
        </el-col> -->
        <!-- <div class="form-wrap" style="border:5px solid green;"> -->
        <el-col :xs="24" :sm="24" :md="10" :lg="10" class="form-wrap">
            <!-- <img class="form-logo" src="../../static/img/ibroadcast/logo_record.png" v-if="loginType === 'irecord'">
            <img class="form-logo" src="../../static/img/ibroadcast/logo_guest.png" v-else-if="loginType === 'press'">
            <img class="form-logo" src="../../static/img/ibroadcast/logo_check.png" v-else-if="loginType === 'audit'">
            <img class="form-logo" src="../../static/img/ibroadcast/logo_monitor.png" v-else-if="loginType === 'stats'">
            <img class="form-logo" src="../../static/img/ibroadcast/logo_editor.png" v-else> -->
            <img class="form-logo" src="../../static/img/ibroadcast/zwlogo_512.png" >
            <el-tag type="gray">{{getAppVer}}</el-tag>
            <el-form :model="form" :rules="rules" ref="form" class="form-content">
                <el-form-item prop="name">
                    <el-input :placeholder="loginNameStr" v-model="form.name" class="mt-20" size="large">
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" :placeholder="loginPasswdStr" v-model="form.password" class="mt-20" size="large">
                    </el-input>
                </el-form-item>
                <el-button type="primary" class="content-login"  @click="onLogin('form')">登录</el-button>
            </el-form>
            <!-- <span class="form-jump">
                <el-button type="text"  @click="jumpLoginUrl('ieditor')" v-if="loginType !== 'ieditor' && loginType !== 'default' && loginType !== 'press'">跳转到编辑端</el-button>
                <el-button type="text" @click="jumpLoginUrl('irecord')" v-if="loginType !== 'irecord' && loginType !== 'press'">跳转到录音端</el-button>
                <el-button type="text" @click="jumpLoginUrl('audit')" v-if="loginType !== 'audit' && loginType !== 'press'">跳转到审核端</el-button> -->
                <!-- <el-button type="text" @click="jumpLoginUrl('press')" v-if="loginType !== 'press'">跳转到新闻端</el-button> -->
                <!-- <el-button type="text" @click="jumpLoginUrl('stats')" v-if="loginType !== 'stats' && loginType !== 'press'">跳转到统计端</el-button>
            </span> -->
        </el-col>
        <!-- </div> -->
    </el-row>
    <!-- </div> -->

</div>
</template>

<script type="text/javascript">
import '../../static/style/logins/login.scss';
import { routeMap } from '../../utils/com.js'
import {mapGetters, mapActions} from 'vuex';

// 可以用滑块组件做右滑登录认证
export default {
    data() {
        return {
            loginNameStr: '用户名',
            loginPasswdStr: '密码',
            form: {
                name: '',
                password: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入数据', trigger: 'blur' },
                    { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入数据', trigger: 'blur' },
                    { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        // console.info("path:%o, params:%o, query:%o", this.$store.state.route.path, this.$store.state.route.params, this.$store.state.route.query);
        console.info("getAppVer:%o", this.getAppVer);
        let appid = this.$store.state.route.query.appid || '';
        let token = this.$store.state.route.query.token || '';
        console.debug("created> appid:%o, token:%o", appid, token);
        if(appid && token){
            // let param = { appid, token};
            // this.TokenLogin(param);
            this.form.name = appid;
            this.form.password = token;
            this.$store.dispatch('TokenLogin', this)
        }
    },
    computed: {
        ...mapGetters({
            // 映射 this.getAppVer 为 store.getters.getAppVer
            getAppVer: 'getAppVer'
        }),
        loginType(){
            let type = this.$store.state.route.query.type || 'press';
            console.debug("loginType> %o", type);
            if(type === 'press'){
                this.loginNameStr = 'App ID';
                this.loginPasswdStr = 'App Secret';
            }else{
                this.loginNameStr = '用户名';
                this.loginPasswdStr = '密码';
            }
            console.debug("created> loginNameStr:%o, loginPasswdStr:%o", this.loginNameStr, this.loginPasswdStr);
            return type
        }
    },
    methods: {
        ...mapActions({
          // 映射 this.TokenLogin() 为 this.$store.dispatch('TokenLogin')
          TokenLogin: 'TokenLogin',
        }),
        onLogin(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 执行登录
                    if(this.loginType === 'press'){
                        this.$store.dispatch('AppIdLogin', this)
                    }else{
                        this.$store.dispatch('onLogin', this)
                    }
                } else {
                    if(this.loginType === 'press'){
                        this.$alert('密码错误', '系统通知', { confirmButtonText: '确定' })
                    }else{
                        this.$alert('用户名 或 密码不能为空', '系统通知', { confirmButtonText: '确定' })
                    }
                }
            });
        },
        jumpLoginUrl(type){
            // console.debug("jumpLoginUrl> type:%o", type);
            this.$router.push({ path: routeMap('/login'),query: { type: type }})
        }
    }
}
</script>



// WEBPACK FOOTER //
// login.vue?ae5eb0ee